import { combineReducers } from "redux-immutable";
import { playReducer as play } from "./features/play";
import { locationReducer as location } from "./features/location";
import { securityReducer as security } from "./security";
import { accountReducer as account } from "./features/account/";
import { contactsReducer as contact } from "./features/contact/";
import { usageReducer as usage } from "./features/usage/";
import { invoiceReducer as invoice } from "./features/invoice/";
import { taxReducer as tax } from "./features/tax/";
import { rateReducer as rate } from "./features/rate/";
import { meterReducer as meter } from "./features/meter/";
import { reportReducer as report } from "./features/report/";
import { uploadReducer as upload } from "./features/upload/";
import { copReducer as cop } from "./features/cop/";
import { readingReducer as reading } from "./features/reading/";
import status from "./statusReducer";

export default combineReducers({
  play,
  security,
  account,
  location,
  contact,
  usage,
  invoice,
  tax,
  rate,
  meter,
  report,
  upload,
  cop,
  status,
  reading
});



// WEBPACK FOOTER //
// ./src/rootReducer.js